import { makeObservable, observable, action } from "mobx";

import { LabelValue } from "../../../../models/Dashboard/Analytics";
import UrgentSourcingAnalyticsDashboardAPI from "../../api/dashboards/UrgentSourcingAnalyticsDashboardAPI";
import { UrgentSourcingAnalyticsAPIFilters } from "../../../../models/Dashboard/UrgentSourcingDashboard/UrgentSourcingAnalyticsFilters";

export class UrgentSourcingAnalyticsDashboardStore {
  analyticsAPI: UrgentSourcingAnalyticsDashboardAPI;
  basic_tats: LabelValue[];

  constructor() {
    this.analyticsAPI = new UrgentSourcingAnalyticsDashboardAPI();
    this.basic_tats = [];

    makeObservable(this, {
      basic_tats: observable,
      getUrgentSourcingAnalyticsTats: action,
    });
  }

  getUrgentSourcingAnalyticsTats = async (
    filters: UrgentSourcingAnalyticsAPIFilters
  ) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "/tats",
        filters
      )) as LabelValue[];
      this.basic_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };
}
